export default {
  sm: `
  데이터센터 각은 데이터를
  안전하게 지키고 서비스의 안정성을
  확보하기 위해 지속 가능한 첨단기술과
  시스템으로 운영됩니다.
  `,
  lg: `
  데이터센터 각은 데이터를 안전하게 지키고
  서비스의 안정성을 확보하기 위해
  지속 가능한 첨단기술과 시스템으로 운영됩니다.
  `,
};``
